import { getExternalPlatformIdFromInternalPlatformId, getInternalPlatformIdFromExternalPlatformId, 
// RPC types
ORBY_SET_CUSTOM_PLATFORM_ENDPOINTS_FOR_INSTANCE, ORBY_REMOVE_CUSTOM_PLATFORM_ENDPOINTS_FOR_INSTANCE, ORBY_GET_CUSTOM_PLATFORM_ENDPOINTS_FOR_INSTANCE, ORBY_ENABLE_PLATFORM_ABSTRACTION_FOR_INSTANCE, ORBY_ENABLE_GAS_SPONSORSHIP_FOR_INSTANCE, ORBY_GET_GAS_SPONSOR_FOR_INSTANCE, ORBY_GET_ORBY_GAS_SPONSOR_POLICY_FOR_INSTANCE, ORBY_SET_ORBY_GAS_SPONSOR_POLICY_FOR_INSTANCE, ORBY_REMOVE_ORBY_GAS_SPONSOR_POLICY_FOR_INSTANCE, } from "@orb-labs/types";
import { extractGasSponsorshipPolicy } from "../utils/action_helpers.js";
import { LibraryRequest } from "../actions/library_request.js";
export class InstanceActions extends LibraryRequest {
    constructor(library, client, provider) {
        super(library, client, provider);
    }
    async setCustomPlatformEndpointsForInstance(chainEndpoints) {
        const promises = chainEndpoints.map(async (endpoint) => ({
            platformId: getExternalPlatformIdFromInternalPlatformId(endpoint.platformId),
            customRpcUrls: endpoint.customRpcUrls,
            customIndexerUrls: endpoint.customIndexerUrls,
        }));
        const formattedEndpoints = await Promise.all(promises);
        const { success, code, message } = await this.sendRequest(ORBY_SET_CUSTOM_PLATFORM_ENDPOINTS_FOR_INSTANCE, [{ chainEndpoints: formattedEndpoints }]);
        if (code && message) {
            console.error("[setCustomPlatformEndpointsForInstance]", code, message);
            return undefined;
        }
        return success;
    }
    async removeCustomPlatformEndpointForInstance(platformIds) {
        const promises = platformIds.map(async (platformId) => getExternalPlatformIdFromInternalPlatformId(platformId));
        const formattedPlatformIds = await Promise.all(promises);
        const { success, code, message } = await this.sendRequest(ORBY_REMOVE_CUSTOM_PLATFORM_ENDPOINTS_FOR_INSTANCE, [{ platformIds: formattedPlatformIds }]);
        if (code && message) {
            console.error("[removeCustomPlatformEndpointForInstance]", code, message);
            return undefined;
        }
        return success;
    }
    async getCustomPlatformEndpointsForInstance(returnPlatformIdsOnly) {
        const { chainEndpoints, code, message } = await this.sendRequest(ORBY_GET_CUSTOM_PLATFORM_ENDPOINTS_FOR_INSTANCE, [{ returnPlatformIdsOnly }]);
        if (code && message) {
            console.error("[getCustomPlatformEndpointsForInstance]", code, message);
            return undefined;
        }
        return (chainEndpoints?.map((endpoint) => ({
            platformId: getInternalPlatformIdFromExternalPlatformId(endpoint.platformId),
            customRpcUrls: endpoint.customRpcUrls,
            customIndexerUrls: endpoint.customIndexerUrls,
        })) ?? []);
    }
    async enablePlatformAbstractionForInstance(enable) {
        const { success, code, message } = await this.sendRequest(ORBY_ENABLE_PLATFORM_ABSTRACTION_FOR_INSTANCE, [{ enable }]);
        if (code && message) {
            console.error("[enablePlatformAbstractionForInstance]", code, message);
            return undefined;
        }
        return success;
    }
    async enableGasSponsorshipForInstance(enable) {
        const { success, code, message } = await this.sendRequest(ORBY_ENABLE_GAS_SPONSORSHIP_FOR_INSTANCE, [{ enable }]);
        if (code && message) {
            console.error("[enableGasSponsorshipForInstance]", code, message);
            return undefined;
        }
        return success;
    }
    async getGasSponsorForInstance() {
        const { gasSponsor, code, message } = await this.sendRequest(ORBY_GET_GAS_SPONSOR_FOR_INSTANCE, []);
        if (code && message) {
            console.error("[getGasSponsorForInstance]", code, message);
            return undefined;
        }
        return gasSponsor;
    }
    async getOrbyGasSponsorPolicyForInstance() {
        const { gasSponsorshipPolicy, message, code } = await this.sendRequest(ORBY_GET_ORBY_GAS_SPONSOR_POLICY_FOR_INSTANCE, []);
        if (code && message) {
            console.error("[getOrbyGasSponsorPolicyForInstance]", code, message);
            return undefined;
        }
        return extractGasSponsorshipPolicy(gasSponsorshipPolicy);
    }
    async setOrbyGasSponsorPolicyForInstance(gasSponsorshipPolicy) {
        const { success, code, message } = await this.sendRequest(ORBY_SET_ORBY_GAS_SPONSOR_POLICY_FOR_INSTANCE, [{ ...gasSponsorshipPolicy }]);
        if (code && message) {
            console.error("[setOrbyGasSponsorPolicyForInstance]", code, message);
            return undefined;
        }
        return success;
    }
    async removeOrbyGasSponsorPolicyForInstance() {
        const { success, code, message } = await this.sendRequest(ORBY_REMOVE_ORBY_GAS_SPONSOR_POLICY_FOR_INSTANCE, []);
        if (code && message) {
            console.error("[removeOrbyGasSponsorPolicyForInstance]", code, message);
            return undefined;
        }
        return success;
    }
}
